import { DRAWER_EXPANDED_WIDTH_MAX, DRAWER_EXPANDED_WIDTH_MIN } from '../SidebarNavigationDrawer.constant';

/** Keeps a drawer width inside the resizable range; the maximum depends on the current screen width. */
export const clampDrawerWidth = (width: number): number =>
  Math.max(DRAWER_EXPANDED_WIDTH_MIN, Math.min(DRAWER_EXPANDED_WIDTH_MAX, width));
